import styled from 'styled-components'
import { Link } from 'react-router-dom'
import media from '../../../services/generateMediaQueries'
import ActionButton from '../../ui/ActionButton/ActionButton'

/** Class added around each article table so only that strip scrolls horizontally on small screens. */
export const MCM_TABLE_SCROLL_CLASS = 'mcm-table-scroll'

export const ShareButtons = styled.div`
  display: none;
  position: absolute;
  width: 250px;
  margin-left: -200px;
  text-align: center;
  top: 0;

  ${media.lessThan('small')`
    width: min(250px, calc(100vw - 3rem));
    margin-left: 0;
    right: 0;
    left: auto;
  `}

  & > div {
    cursor: pointer;
    border-radius: 100%;
    display: inline-block;
    margin-right: 3px;
    box-shadow: 1px 3px 3px 2px rgba(85, 69, 13, 0.2);
  }
  & > div:hover {
    box-shadow: 1px 3px 3px 5px rgba(85, 69, 13, 0.2);
  }
  & > div:last-child {
    margin-right: 0;
  }
`

export const ShareContainer = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  right: 2.625rem;
  top: -1.125rem;

  ${media.lessThan('small')`
    right: 1rem;
  `}

  &:hover > div {
    display: block;
  }
  &:hover > button {
    display: none;
  }
`

export const ShareBaseButton = styled(ActionButton)`
  max-width: 100%;
`

export const ContentContainer = styled.div`
  position: relative;
  min-width: 0;
  box-sizing: border-box;
  margin: 0 3.625rem;
  margin-top: -100px;
  margin-bottom: 3.625rem;
  background: #ffffff;
  padding: 4rem 3.125rem;
  border-radius: var(--border-radius-card);
  box-shadow: var(--box-shadow-medium);

  ${media.lessThan('small')`
  margin: 0;
  padding: 3.25rem 2.75rem;
  border-radius: 0;
  max-width: 100%;
`}
`

export const Container = styled.div`
  flex: 1;
  min-width: 0;
  background: var(--color-bg-light);
`

export const Title = styled.h1`
  font-size: 1.375rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.9375rem;
  margin: 0;
  margin-bottom: 1.625rem;
  text-transform: uppercase;

  ${media.lessThan('small')`
  font-size: 1rem;
`}
`

export const Subtitle = styled.h5`
  margin: 3rem 0 1rem;
  font-size: 1rem;
  font-weight: var(--font-weight-bold);
  color: var(--color-primary);
  text-transform: uppercase;
`

export const Schedule = styled.span`
  display: inline-block;
  font-size: 0.625rem;
  line-height: 1rem;
  font-weight: var(--font-weight-boldest);
  letter-spacing: var(--letter-spacing-wide);
  padding: 7px 16px;
  max-width: 100%;
  margin: 0;
  margin-bottom: 2.25rem;
  background: var(--color-bg);
  border-radius: var(--border-radius-small);
  color: #9b9b9b;
  text-transform: uppercase;
`

export const Body = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;

  img,
  video,
  iframe,
  embed,
  object {
    max-width: 100%;
    height: auto;
  }

  pre {
    max-width: 100%;
    overflow-x: auto;
  }

  > p {
    &:first-child {
      margin-top: 0;
    }
  }

  ${media.lessThan('small')`
    overflow-wrap: anywhere;

    table {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0;
      box-sizing: border-box;
      table-layout: fixed;
      border-collapse: collapse;
      font-size: max(0.625rem, 2.5vw);
      overflow-wrap: anywhere;
    }

    th,
    td {
      word-break: break-word;
      overflow-wrap: anywhere;
      white-space: normal;
      vertical-align: top;
      box-sizing: border-box;
      padding: 0.3rem 0.15rem;
    }

    .${MCM_TABLE_SCROLL_CLASS} {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      max-width: 100%;
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }

    .${MCM_TABLE_SCROLL_CLASS} table {
      width: max-content !important;
      min-width: 100%;
      max-width: none !important;
      box-sizing: border-box;
      table-layout: auto !important;
      border-collapse: collapse;
      font-size: max(0.75rem, 2.5vw);
    }

    .${MCM_TABLE_SCROLL_CLASS} th,
    .${MCM_TABLE_SCROLL_CLASS} td {
      white-space: nowrap;
      word-break: normal;
      overflow-wrap: normal;
      vertical-align: top;
      box-sizing: border-box;
      padding: 0.35rem 0.5rem;
    }

    figure table,
    > figure > table,
    figure > .${MCM_TABLE_SCROLL_CLASS} {
      margin-left: 0;
      margin-right: 0;
    }
  `}

  > figure {
    margin: 0;
    max-width: 100%;

    > img {
      max-width: 100%;
    }

    > .${MCM_TABLE_SCROLL_CLASS} {
      ${media.greaterThan('small')`
        margin: 0 -0.5rem;
      `}
    }

    > table {
      width: 100%;
      border-collapse: collapse;

      ${media.greaterThan('small')`
        margin: 0 -0.5rem;
      `}

      td,
      th {
        border: 1px solid #ccc;

        ${media.greaterThan('small')`
          padding: 0 0.5rem;
        `}
      }
    }

    > .${MCM_TABLE_SCROLL_CLASS} > table {
      width: 100%;
      border-collapse: collapse;

      td,
      th {
        border: 1px solid #ccc;

        ${media.greaterThan('small')`
          padding: 0 0.5rem;
        `}
      }
    }
  }

  margin-bottom: 4rem;
`

export const RelatedContainer = styled.div`
  padding: 3.625rem;
  padding-top: 0;

  ${media.lessThan('small')`
  padding: 2rem 1.25rem;
`}
`

export const RelatedTitle = styled.h2`
  color: var(--color-primary);
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: var(--font-weight-bold);
  margin: 0;
  margin-bottom: 2rem;

  ${media.lessThan('medium')`
  font-size: 0.875rem;
`};
`

export const MallList = styled.div`
  display: flex;
  flex-direction: row;
  overflow: auto;
  padding: 0.5rem 0;
`

export const StyledLink = styled(Link)`
  position: relative;
  margin-right: 0.5rem;
  cursor: pointer;
  transition: all var(--animation-duration) var(--animation-easing);

  &:hover {
    &:after {
      content: ' ';
      position: absolute;
      background: var(--color-primary-hover);
      height: 4px;
      width: 100%;
      bottom: 0;
      transition: all var(--animation-duration) var(--animation-easing);
    }
  }
`

export const MallLogo = styled.div.attrs(props => ({
  style: {
    background: `url('${props.logo}') no-repeat center /contain`,
  },
}))`
  height: 86px;
  width: 86px;
`

export const ReferenceWidth = styled.div`
  width: 100%;
  min-width: 0;
  flex-shrink: 0;
`

export const AspectRatioHelper = styled.div`
  width: 100%;
  padding-bottom: calc(100% / (16 / 9));
  position: relative;
`

export const StyledBanner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background-image: ${({ background }) => `url('${background}')`};
  background-size: cover;
  background-position: center;
`
